import { FormikValues } from 'formik';
import { FactDefinition } from '../../gen/api';
import useFieldHelpers from '../../helpers/fieldHelper';
import { FactConfig } from '../settings/config';
import { mandatoryFieldValidator } from './MandatoryFieldValidator';
import { EffectiveFactBehaviourEnum } from '../../components/ConfigurationForm/ConfigurationFormSchema';

const { getEffectiveFactBehaviour } = useFieldHelpers();

const useFieldValidation = () => {
    const isFieldMandatory = (factDefinition: FactDefinition, values: FormikValues) => {
        return getEffectiveFactBehaviour(factDefinition, values) == EffectiveFactBehaviourEnum.MANDATORY;
    };

    const getFieldValidators = (mandatory: boolean, factConfig: FactConfig) => {
        if (factConfig.props.validator) {
            if (mandatory) {
                return [factConfig.props.validator, mandatoryFieldValidator];
            } else {
                return [factConfig.props.validator];
            }
        } else if (mandatory) {
            return [mandatoryFieldValidator];
        }
        return undefined;
    };

    const compositeFieldLevelValidator = (value: any, mandatory: boolean, factConfig: FactConfig) => {
        return new Promise<string>((resolve) => {
            const validators = getFieldValidators(mandatory, factConfig);

            if (!validators) {
                return resolve();
            }

            for (const validation of validators) {
                const result = validation(value);
                if (result) {
                    return resolve(result);
                }
            }
            return resolve();
        });
    };

    return {
        isFieldMandatory,
        compositeFieldLevelValidator,
    };
};

export default useFieldValidation;
